import { render } from "./amount.vue?vue&type=template&id=293dacd4&scoped=true"
import script from "./amount.vue?vue&type=script&lang=js"
export * from "./amount.vue?vue&type=script&lang=js"

import "./amount.vue?vue&type=style&index=0&id=293dacd4&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293dacd4"]])

export default __exports__